import { render, staticRenderFns } from "./responderMensagem.vue?vue&type=template&id=03927fe1&lang=pug&"
import script from "./responderMensagem.vue?vue&type=script&lang=js&"
export * from "./responderMensagem.vue?vue&type=script&lang=js&"
import style0 from "./responderMensagem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports